<script>
import { replaceWindowHistory, getUrlParameter } from "@utils/window-history";
import formatTextUpperCasefirst from "@utils/format-text-upper-casefirst";

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    tabList: {
      type: Array,
      default: () => {
        return [
          {
            title: '標題',
            name: 'name',
            icon: '',
            to: {
              nmae: 'home'
            } // 非必填
          },
          {
            title: '標題2',
            name: 'name2',
            icon: '',
            to: {
              nmae: 'home'
            }
          }
        ]
      }
    },
    name: {
      type: String,
      default: 'activeTab'
    },
    type: {
      type: String,
      default: 'base',
      validator(value) {
        return [
          'base',
          'jtails',
          'jtailsStore',
          'jtailsReservation',
          'jtailsDialogStore',
          'jtailsMenu',
          'jtailsPrepaid',
          'jtailsWordpress',
          'jtailsOrderReservation'
        ].includes(value)
      },
    },
    isStretch: {
      type: Boolean,
      default: true,
    },
    isInitQuery: {
      type: Boolean,
      default: false,
    },
    isQuerySet: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    activeTab: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
  },
  watch: {
    activeTab(newValue, oldValue) {
      this.$emit('change', newValue);
    }
  },
  created() {
    const initActiveTab = () => {
      const query = getUrlParameter(this.name);

      const isValid = (query) => {
        return this.tabList.some(({ name }) => name === query)
      };

      if(!!query && isValid(query))
        this.activeTab = query
    };

    initActiveTab();
    if(this.isInitQuery && this.isQuerySet) {
      this.replaceHistory();
    }
  },
  destroyed() {
    replaceWindowHistory({
      query: {
        [this.name]: ''
      }
    });
  },
  methods: {
    formatTextUpperCasefirst,
    onTabClick(tab, event) {
      this.$nextTick(() => {
        if(this.type === 'jtailsMenu') {
          const tabItems = this.tabList.filter(item => {
            return item.name === this.activeTab
          });

          let routeTo = tabItems[0]
            ? tabItems[0].to
            : '';
          if(this.$route.name === 'spa') {
            routeTo = tabItems[0].name
            this.$router.replace({
              name: 'spa',
              params: {
                spaAlias: routeTo	
              }	
            })	
          } else {
            this.$router.push(routeTo);
          }
        } else {
          if(this.isQuerySet) {
            this.replaceHistory()
          }
        }
      });
    },
    replaceHistory() {
      replaceWindowHistory({
        query: {
          [this.name]: this.activeTab && this.activeTab !== 'all'
            ? this.activeTab
            : ''
        }
      });
    }
  },
}
</script>
<!-- section template -->
<template>
  <el-tabs
    v-model="activeTab"
    :class="[$style.baseTab, `isStyle${formatTextUpperCasefirst(type)}`, {
      'isStyleDingBeauty': $globalIsDingBeauty,
    }]"
    :stretch="isStretch"
    @tab-click="onTabClick"
  >
    <el-tab-pane
      v-for="(tabItem, index) in tabList"
      :key="index"
      :name="tabItem.name"
    >
      <span slot="label">
        <i
          v-if="tabItem.icon"
          :class="[tabItem.icon, `el-tabs__icon`]"
        ></i>
        <span v-html="tabItem.title"></span>
      </span>
    </el-tab-pane>
  </el-tabs>
</template>
<!-- section style -->
<style lang="scss" module>
.baseTab {
  :global {
    .baseFilter {
      @include unstyled;
    }
  }
}
</style>
